export default __webpack_public_path__ + "static/media/helix-bridge.ed4e302d.svg";